"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runOnReadyState = runOnReadyState;
exports.asyncRunOnReadyState = asyncRunOnReadyState;
const functionUtils_1 = require("../tools/utils/functionUtils");
const addEventListener_1 = require("./addEventListener");
function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
        return { stop: functionUtils_1.noop };
    }
    const eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
    return (0, addEventListener_1.addEventListener)(configuration, window, eventName, callback, { once: true });
}
function asyncRunOnReadyState(configuration, expectedReadyState) {
    return new Promise((resolve) => {
        runOnReadyState(configuration, expectedReadyState, resolve);
    });
}
//# sourceMappingURL=runOnReadyState.js.map